<script>
export default {
  name: "Jsx",
  props: {
    renderFuc: {
      type: Function,
      required: true
    }
  },
  render(createElement, context) {
    return this.renderFuc(createElement, context)
  }
}
</script>
